import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { HeaderService } from 'src/app/components/header/header.service';
import { SnackbarComponent } from 'src/app/components/snackbar/snackbar.component';
import { GetSingleSkuPayload, GetWalmartSingleSkuPayload } from 'src/app/models/inventory.model';
import { InventoryService } from 'src/app/services/inventory.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-import-single-sku',
  templateUrl: './import-single-sku.component.html',
  styleUrls: ['./import-single-sku.component.scss']
})
export class ImportSingleSkuComponent implements OnInit, OnDestroy {
  searchText: FormControl = new FormControl("", Validators.required);
  loadingSku: boolean = false;
  account:string;
  skuImported : boolean | null = null;
  private destroy$ = new Subject<void>();
  accountType: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    public dialogRef: MatDialogRef<ImportSingleSkuComponent>,
    private inventoryService: InventoryService,
    private snackBar: MatSnackBar,
    private headerService:HeaderService,
  ) { }

  ngOnInit(): void {
    this.headerService.accountsSelected.pipe(takeUntil(this.destroy$)).subscribe((e) => {
      this.account = e[0];
    })
    this.headerService.accountSelectedType
    .pipe(takeUntil(this.destroy$))
    .subscribe((e) => {
      if (e) {
        this.accountType = e[0];        
      }
    });
  }

  loadSku(){
    this.loadingSku = true;
    let payload: GetSingleSkuPayload ={
      isSku: true,
      value: this.searchText.value,
      account: this.account
    }
    let walmartPayload: GetWalmartSingleSkuPayload = {
      sku: this.searchText.value,
      account: this.account
    }
    let apiLink = this.accountType == 'Walmart' ? this.inventoryService.GetWalmartSingleSku(walmartPayload) : this.inventoryService.GetSingleSku(payload);
    apiLink.pipe(takeUntil(this.destroy$)).subscribe({
    next: (res:boolean) => {
      this.skuImported = res ;
      this.loadingSku = false;
    },
     error: (err) => {
      this.loadingSku = false;  
      this.snackBar.openFromComponent(SnackbarComponent,
        {
          duration: 4000,
          horizontalPosition: 'center',
          data: {
            title: err.error?.error[0],
            action: 'Dismiss',
            type: 'error',
          },
        }
      );
     }
    });    
  }

  close() {
    this.dialogRef.close();
  }

  action(e) {
    this.close();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
}
